/**
 * Sticky Utilities
 */

// Vendors
import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';
import 'waypoints/lib/jquery.waypoints.min';

// Init local scroll
$('.sticky-utilities').localScroll({
  duration: 1000,
  easing: 'easeInOutExpo'
});

// Create waypoint
const windowWaypoint = new Waypoint({
  element: window,
  offset: -200,
  handler: (direction) =>
    $('.sticky-utilities').toggleClass(
      'sticky-utilities--visible',
      direction === 'down'
    )
});

// Stick sticky bottom position
$(() => setStickyBottomPosition());
$(() => setStickyTopPosition());
$(window).on('load scroll resize', () => setStickyBottomPosition());
$(window).on('load scroll resize', () => setStickyTopPosition());

function setStickyBottomPosition() {
  const windowHeight = $(window).height();
  const windowScrollPosition = $(window).scrollTop();
  const footerPosition = $('.site-footer-spacer').offset();

  if (!footerPosition) return;

  if (windowScrollPosition + windowHeight >= footerPosition.top)
    return $('.sticky-utilities').addClass('sticky-utilities--footer-in-view');

  $('.sticky-utilities').removeClass('sticky-utilities--footer-in-view');
}

function setStickyTopPosition() {
  const windowWidth = $(window).width();
  const headerHeight = $('.site-header-desktop').height();

  if (!headerHeight) return;

  if (windowWidth <= 992) {
    $('.sticky-utilities > ul').css('top', `auto`);

    return;
  }

  $('.sticky-utilities > ul').css('top', `calc(50% + ${headerHeight}px)`);
}
